var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSocChargeTransactionOnMonth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 44,
    viewBox: "0 0 42 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40341 17.2857L6.4706 11.4656C7.29747 9.19575 9.42373 7.68253 11.8453 7.68253H22.5356C24.9572 7.68253 27.0834 9.19575 27.9103 11.4656L30 19C25 19.5 21 19.5 21 27.2381C21 27.8783 21 28.5185 21.1181 29.1005H8.39998V31.6614C8.39998 32.709 7.51404 33.5238 6.50998 33.5238H3.98998C2.92685 33.5238 2.09998 32.709 2.09998 31.6614V20.7196C2.09998 19.2063 3.04498 17.8677 4.40341 17.2857Z",
    fill: "#03E8AF",
    fillOpacity: 0.1,
    stroke: "#1EF5DF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90002 20.9524H11.2064C12.7493 20.9524 14 22.2032 14 23.746V23.746",
    stroke: "#87FF0B",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.9 16.7619H8.40002L9.95293 12.455C10.1918 11.6984 10.9086 11.1746 11.7447 11.1746H22.5553C23.3915 11.1746 24.1082 11.6984 24.3471 12.455L25.9 16.7619Z",
    fill: "#1EF5DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22V23.5M29 22V23.5",
    stroke: "#1EF5DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0416 25.6667H35.9583",
    stroke: "#1EF5DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4584 28.1419C25.4584 25.6001 25.4584 24.3292 26.1888 23.5396C26.9192 22.75 28.0947 22.75 30.4459 22.75H31.5542C33.9053 22.75 35.0809 22.75 35.8113 23.5396C36.5417 24.3292 36.5417 25.6001 36.5417 28.1419V28.4414C36.5417 30.9832 36.5417 32.2541 35.8113 33.0437C35.0809 33.8333 33.9053 33.8333 31.5542 33.8333H30.4459C28.0947 33.8333 26.9192 33.8333 26.1888 33.0437C25.4584 32.2541 25.4584 30.9832 25.4584 28.4414V28.1419Z",
    stroke: "#1EF5DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 25.6667H36.25",
    stroke: "#1EF5DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1429 28.3571H34.5715",
    stroke: "#1EF5DF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1429 30.5H31.3572",
    stroke: "#1EF5DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocChargeTransactionOnMonth);
export default __webpack_public_path__ + "static/media/ic_soc_charge_transaction_on_month.4b47f64768bb3c26002cb0c881f97b80.svg";
export { ForwardRef as ReactComponent };